import React, {useState, Suspense} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import UI from "components/UI";
import UIDatePicker from "components/datepicker";
import TbSysNoti from "domain/main/sys/noti/TbSysNoti";
import TbComFile from "domain/main/com/file/TbComFile";
import UIUtils from "utils/UIUtils";

function ContentsContainer() {
    const history = useHistory();
    const location = useLocation();
    const [notiNo, setNotiNo] = useState('');
    const [notiTpCd, setNotiTpCd] = useState('E');
    const [notiStsCd, setNotiStdCd] = useState('Y');
    const [notiTitle, setNotiTitle] = useState('');
    const [notiCont, setNotiCont] = useState('');
    const [fileId, setFileId] = useState('');

    const [notiFileValue] = useState(new TbComFile());

    const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
    const [thumbInfoList, setThumbInfoList] = React.useState<any[]>([]);

    // 폼체크 여부
    const [formCheck,setFormCheck] = useState(false);

    //파일업로드
    const [uploadId, setUploadId] = React.useState("");
    const [uploadIdThumb, setUploadIdThumb] = React.useState("");

    //파일업로드
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

    const onCreationCompleteThumb = function (uploadID: string) {
        setUploadIdThumb(uploadID);
    }

    //파일업로드 완료
    const onUploadComplete = (type) => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
        console.log(JSON.stringify(arrayNew));

        let fileInfos : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_GB:string;
            FILE_STATUS:string;
        }[] = [];

        let fileInfo : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_GB:string;
            FILE_STATUS:string;
        };

        //파일등록 정보
        arrayNew?.map((item, index) => {
            if(item.status =="complete"){
                fileInfo = {
                    FILE_DETAIL_ID:item.uniqKey,
                    ORGINL_FILE_NM:item.originalName,
                    STRE_FILE_NM:item.uploadName,
                    FILE_SIZE:item.size,
                    STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                    FILE_EXTSN:item.extension,
                    FILE_GB:type,
                    FILE_STATUS:"ADD"
                }

                fileInfos.push(fileInfo);
            }

            console.log("fileInfos : "+JSON.stringify(fileInfos));
        })

        //파일등록 정보
        arrayDel?.forEach((item, index) => {
            fileInfo = {
                FILE_DETAIL_ID:item.uniqKey,
                ORGINL_FILE_NM:item.originalName,
                STRE_FILE_NM:item.uploadName,
                FILE_SIZE:item.size,
                STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                FILE_EXTSN:item.extension,
                FILE_GB:type,
                FILE_STATUS:"DEL"
            }

            fileInfos.push(fileInfo);

        })
        setFileInfoList(fileInfos);

    }

    const onUploadCompleteThumb = (type) => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadIdThumb);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
        console.log(JSON.stringify(arrayNew));

        let thumbFileInfos : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_GB:string;
            FILE_STATUS:string;
        }[] = [];

        let thumbFileInfo : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_GB:string;
            FILE_STATUS:string;
        };

        //파일등록 정보
        arrayNew?.forEach((item, index) => {
            thumbFileInfo = {
                FILE_DETAIL_ID:item.uniqKey,
                ORGINL_FILE_NM:item.originalName,
                STRE_FILE_NM:item.uploadName,
                FILE_SIZE:item.size,
                STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                FILE_EXTSN:item.extension,
                FILE_GB:type,
                FILE_STATUS:"ADD"
            }

            thumbFileInfos.push(thumbFileInfo);
        })

        //파일등록 정보
        arrayDel?.forEach((item, index) => {
            thumbFileInfo = {
                FILE_DETAIL_ID:item.uniqKey,
                ORGINL_FILE_NM:item.originalName,
                STRE_FILE_NM:item.uploadName,
                FILE_SIZE:item.size,
                STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                FILE_EXTSN:item.extension,
                FILE_GB:type,
                FILE_STATUS:"DEL"
            }

            thumbFileInfos.push(thumbFileInfo);

        })
        console.log("ThumbFileInfo : " + thumbFileInfos);
        setThumbInfoList(thumbFileInfos);

    }

    const onFileUpload = () => {
        console.log("onFileUpload : " + uploadId);
        // if(uploadId){
        //     window["RAONKUPLOAD"].Transfer(uploadId);
        // }
        window["RAONKUPLOAD"].MultiTransfer();
        setFormCheck(true);
    }

    const onFileUploadThumb = () => {
        console.log("onFileUploadThumb : " + uploadIdThumb);
        if(uploadIdThumb){
            window["RAONKUPLOAD"].Transfer(uploadIdThumb);
        }
    }


    //초기 데이터 설정
    let data = {};
    let param = {};

    const handleSelect = (e) => {
        if(e.target.name === 'notiStsCd'){
            setNotiStdCd(e.target.value);
        }
    };

    const alertModal = async () => {
        const value = await UIUtils.alert(<>
            필수 입력이 완료되지 않았습니다.<br/>
            다시 확인해 주세요.
        </>);
    }

    // 공지사항 저장
    async function notiFormCheck() {

        // 필수값 체크
        if(notiTitle == ''){
            alertModal();
            return;
        }
        if(notiCont == ''){
            alertModal();
            return;
        }

        // 썸네일 파일업로드 영역에 업로드 된 파일 갯수 체크
        console.log("uploadIdThumb : " + uploadIdThumb);
        const ThumbFileListInfo = window["RAONKUPLOAD"].GetListInfo("array", uploadIdThumb);
        console.log("fileListInfo", ThumbFileListInfo);
        console.log(Object.keys(ThumbFileListInfo).length);
        console.log("fileListInfo.mergeFIle", ThumbFileListInfo?.mergeFile);

        if(ThumbFileListInfo?.mergeFile == null){
            alertModal();
            return;
        }

        if(await UIUtils.confirm('저장하시겠습니까?')){

            // setFormCheck(true);
            onFileUpload();
        }
    };

    async function genNotiKey() {

        const response:any = await CommonUtil.execute({
            url:"adm_5120_newIdGen.jct",
            data: {NOTI_TP_CD : notiTpCd}
        });

        return response.LST_GIV_NO;

    }

    async function notiSave(sendParam:any){

        var regNotiNo = await genNotiKey();
        sendParam.NOTI_NO = regNotiNo;

        console.log("sendParam : "+JSON.stringify(sendParam));
        console.log(thumbInfoList);
        if(!thumbInfoList){
            UIUtils.alert("썸네일을 첨부해주세요.").then();
        }

        const response:any = await CommonUtil.execute({
            url:"adm_5120.jct",
            data: sendParam
        }).then((response: any) => {
            regNotiNo = response.NOTI_NO;
            UIUtils.alert("저장되었습니다.").then();
        }).catch((error) => {
            CommonUtil.showAxiosError(error);
            return;
        });

        // 완료 후 상세화면으로 이동
        let dataToSend = { NOTI_NO: regNotiNo};
        history.push({
            pathname: './adm5321',
            state: { data: dataToSend }
        });

    };

    // 목록으로 이동
    async function onClickList(event) {
        event.preventDefault();
        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
            pathname: './adm5320',
        });

    };

    // React.useEffect(() => {
    //     genNotiKey();
    // }, [])

    // React.useEffect(() => {
    //     if(fileInfoList){
    //         onFileUploadThumb();
    //     }
    // }, [fileInfoList])

    // 파일 업로드 성공여부 체크
    React.useEffect(() => {
        if(fileInfoList && formCheck) {
            // 파일 업로드 성공
            param = {
                NOTI_NO : notiNo,
                NOTI_TP_CD : notiTpCd,
                NOTI_TITLE : notiTitle,
                NOTI_STS_CD : notiStsCd,
                NOTI_CONT : notiCont,
                FILE_ID : fileId,
                // FILE_INFO_LIST: fileInfoList.length>0?fileInfoList:null,
                THUMB_INFO_LIST: thumbInfoList.length>0?thumbInfoList:null,
                FILE_INFO_LIST: fileInfoList.concat(thumbInfoList),
            }

            // console.log("param : "+JSON.stringify(param));

            //내용 저장
            notiSave(param);

        }
    }, [fileInfoList])

    return (
        <PageContainer>
            <LayoutAside />
            <div className="fww-con">
                <ul className="fww-brd">
                    <li><Link to="/admin/">홈</Link></li>
                    <li><Link to="#">관리자페이지</Link></li>
                    <li><Link to="#">게시판관리</Link></li>
                    <li><Link to="#">우수사례관리</Link></li>
                </ul>
                <main className="fww-main">
                    <h1 className="tx tx-hd2">우수사례 등록</h1>
                    <form className="fo fo-col2" name="" action="" method="">
                        <div className="inner">
                            <div className="fo-item fo-m-1-3  req">
                                <p className="fo-key">제목</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'} value={notiTitle} placeholder={''} valueChanged={(value) => setNotiTitle(value)}/>
                                </div>
                            </div>
                            <div className="fo-item fo-m-1-3  req">
                                <p className="fo-key">게시상태</p>
                                <div className="fo-value">
                                    <div className="sl sl-md w375">
                                        <select name="notiStsCd" id="notiStsCd" value={notiStsCd} className="" onChange={handleSelect}>
                                            <option value="Y">보임</option>
                                            <option value="N">숨김</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="fo-item fo-m-1-3">
                                <div className="fo-key fdc">
									<span className="req">썸네일<br />
									(pixel: 340 × 270)</span>
                                </div>
                                <div className="fo-value">
                                    <div className='w100p'>
                                        <Suspense>
                                            <UI.FileUpload
                                                onCreationComplete={onCreationCompleteThumb}
                                                onUploadComplete={() => onUploadCompleteThumb('THUMB')}
                                                attrs={{
                                                    MaxTotalFileCount: "1",
                                                    ExtensionAllowOrLimit: "1",
                                                    ExtensionArr: "gif,png,jpg,bmp"
                                                }}
                                            />
                                        </Suspense>
                                    </div>
                                </div>
                            </div>
                            <div className="fo-item fo-m-1-3 req">
                                <p className="fo-key">내용</p>
                                <div className="fo-value">
                                    <UISunEditor value={notiCont} valueChanged={(value) => setNotiCont(value)} />
                                </div>
                            </div>
                            <div className="fo-item fo-m-1-3">
                                <p className="fo-key">첨부파일</p>
                                <div className="fo-value">
                                    <div className='w100p'>
                                        <UI.FileUpload
                                            onCreationComplete={onCreationComplete}
                                            onUploadComplete={() => onUploadComplete('FILE')}
                                            attrs={{
                                                //MaxTotalFileCount: "1",
                                                //ExtensionAllowOrLimit: "1"
                                                ImgPreView: "99",
                                                Views: "thumbs"
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                    <div className="hz-root hz-right hz-gap5">
                        <Button color="pri-o" size="sm" onClick={notiFormCheck}>저장</Button>
                        <Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
                    </div>
                </main>
            </div>
        </PageContainer>
    );
}
export default ContentsContainer;